import { render, staticRenderFns } from "./PopupWorkoutLogConfirmRemoveExtraSet.vue?vue&type=template&id=716e4cf3"
import script from "./PopupWorkoutLogConfirmRemoveExtraSet.vue?vue&type=script&lang=js"
export * from "./PopupWorkoutLogConfirmRemoveExtraSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports